module.exports = __webpack_public_path__ + "img/img2.7539fb11.png";